import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { Button, Col, Row, Card, CardBody, CardTitle } from "reactstrap";
import {
  getDashboardQueueTasks,
  getDashboardSendTasks,
  getDashboardCancelledTasks,
  getDashboardFinishTasks,
} from "../../store/actions";
import DashboardList from "../../components/Lists/DashboardList";
import moment from "moment";
import { dashboardfields, task_status } from "../../constants/task_fields";

// P01021-139: cada tarjeta pide su propia página al servidor, ya filtrada por estado
// (status=8,9 / 3,4,5,6,7 / 1 / 2) — antes se traía tasklist entera de una vez
// (GET /task/getAllTasksType, sin WHERE ni LIMIT) y se repartía en 4 con .filter() en cliente.
const PAGE_SIZE = 10;

class TasksBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
    };
  }

  componentDidMount() {
    this.fetchAll();
  }

  fetchAll() {
    this.props.getDashboardQueueTasks(this.state.user, PAGE_SIZE, 1);
    this.props.getDashboardSendTasks(this.state.user, PAGE_SIZE, 1);
    this.props.getDashboardCancelledTasks(this.state.user, PAGE_SIZE, 1);
    this.props.getDashboardFinishTasks(this.state.user, PAGE_SIZE, 1);
  }

  refresh(event) {
    event.preventDefault();
    this.fetchAll();
  }

  formatTasks(elements) {
    if (!Array.isArray(elements)) return [];
    return elements.map((task) => ({
      ...task,
      status: task_status[task["sgtTaskStatus"]],
      sgpCreated: moment(task["sgpCreated"]).format("DD/MM/YYYY hh:mm"),
    }));
  }

  render() {
    const { queueTasks, sendTasks, cancelledTasks, finishTasks } = this.props;

    return (
      <React.Fragment>
        <Row>
          <Col className="refreshButton">
            <Button onClick={(event) => this.refresh(event)} color="primary" className="btn btn-primary">
              {" "}
              <i size="lg" className="mdi  mdi-refresh"></i>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardTitle style={{ color: "red", margin: "20px" }} className="mb-1">
                {"Canceladas"}
              </CardTitle>
              <CardBody>
                <DashboardList
                  taskslist={{ columns: dashboardfields, rows: this.formatTasks(cancelledTasks?.elements) }}
                  totalPages={cancelledTasks?.totalPages || 0}
                  getEntries={this.props.getDashboardCancelledTasks}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardTitle style={{ color: "green", margin: "20px" }} className="mb-1">
                {"Finalizadas"}
              </CardTitle>
              <CardBody>
                <DashboardList
                  taskslist={{ columns: dashboardfields, rows: this.formatTasks(finishTasks?.elements) }}
                  totalPages={finishTasks?.totalPages || 0}
                  getEntries={this.props.getDashboardFinishTasks}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardTitle style={{ color: "orange", margin: "20px" }} className="mb-1">
                {"Ejecutando/Enviadas"}
              </CardTitle>
              <CardBody>
                <DashboardList
                  taskslist={{ columns: dashboardfields, rows: this.formatTasks(sendTasks?.elements) }}
                  totalPages={sendTasks?.totalPages || 0}
                  getEntries={this.props.getDashboardSendTasks}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardTitle style={{ color: "black", margin: "20px" }} className="mb-1">
                {"Cola"}
              </CardTitle>
              <CardBody>
                <DashboardList
                  taskslist={{ columns: dashboardfields, rows: this.formatTasks(queueTasks?.elements) }}
                  totalPages={queueTasks?.totalPages || 0}
                  getEntries={this.props.getDashboardQueueTasks}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}
const mapStateprops = (state) => {
  return {
    queueTasks: state.getDashboardQueueTasks.tasks,
    sendTasks: state.getDashboardSendTasks.tasks,
    cancelledTasks: state.getDashboardCancelledTasks.tasks,
    finishTasks: state.getDashboardFinishTasks.tasks,
  };
};
export default withRouter(
  connect(mapStateprops, {
    getDashboardQueueTasks,
    getDashboardSendTasks,
    getDashboardCancelledTasks,
    getDashboardFinishTasks,
  })(withNamespaces()(TasksBoard))
);
